// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { useNavigate } from 'react-router-dom';
// import Icon from '../../components/AppIcon';
// import Button from '../../components/ui/Button';
// import BacktestConfiguration from './components/BacktestConfiguration';
// import BacktestResults from './components/BacktestResults';
// import ComparisonMode from './components/ComparisonMode';
// import SavedBacktests from './components/SavedBacktests';
// import LoadingOverlay from 'components/ui/LoadingOverlay';
// import { IoMdRocket } from "react-icons/io";
// import apiUtils from 'utils/apiutils';

// const BacktestingEngine = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState('configure');
//   const [backtestResults, setBacktestResults] = useState([]);
 
  
// const [resultloaded, setresultloaded] = useState(false)


//   const [showComparison, setShowComparison] = useState(false);
//   const [isRunning, setIsRunning] = useState(false);
//   const [resultOfId, setresultOfId] = useState("")

//   const handleBacktestComplete = async (resultsPromise) => {
//     setIsRunning(true);
//     // Simulated delay
//     const results = await new Promise((res) =>
//       setTimeout(() => res(resultsPromise), 2500)
//     );
//     setBacktestResults(results);
//     setIsRunning(false);
//     setActiveTab("results");
//   };


//   const tabs = [
//     { id: 'configure', label: 'Configure', icon: 'Settings', count: null },
//     { id: 'results', label: 'Results', icon: 'BarChart3', count: null },
//     { id: 'saved', label: 'Saved', icon: 'Archive', count: null }
//   ];

//   const handleLoadSavedBacktest = async (id,selectedMainStrategy) => {
//     try {
     
//       setActiveTab("results");
//       setresultloaded(false)
//       setresultOfId(id);

//       const payload ={
//         serial_No: id
//       }

//       const response = await apiUtils.post("/user_backtesting/view_backtest_detail", payload, { showToast: false });

//       if (response) {
//         setBacktestResults({ strategy_type: selectedMainStrategy,data:response.Success});
        
//       } else {
        
//       }
//     } catch (error) {
      
//     } finally {
      
//     }
//   };


//   const quickActions = [
//     {
//       title: 'Bot Marketplace',
//       description: 'Browse pre-built strategies',
//       icon: 'Store',
//       action: () => navigate('/dashboard/bot-marketplace'),
//       color: 'primary'
//     },
//     {
//       title: 'Create New Bot',
//       description: 'Build custom strategy',
//       icon: 'Wrench',
//       action: () => navigate('/dashboard/bot-creation-wizard'),
//       color: 'success'
//     },
//     {
//       title: 'Paper Trading',
//       description: 'Test with virtual funds',
//       icon: 'FileText',
//       action: () => navigate('/dashboard/paper-trading'),
//       color: 'primary'
//     },
//     {
//       title: 'Bot Analytics',
//       description: 'View performance metrics',
//       icon: 'Activity',
//       action: () => navigate('/dashboard/bot-analytics'),
//       color: 'primary'
//     }
//   ];

 

//   return (
//     <div className="bg-background">


//       {/* <MainLoader/> */}
//       <div className="p-6">
//         {/* Page Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="mb-8"
//         >
//           <div className="md:flex items-center justify-between mb-6">
//             <div>
//               <h1 className="text-3xl font-bold text-foreground mb-2">Backtesting Engine</h1>
//               <p className="text-muted-foreground">
//                 Validate your trading strategies with comprehensive historical data analysis
//               </p>
//             </div>

//             <div className="flex flex-col lg:flex-row items-center justify-end space-x-3">
//               <Button
//                 variant="outline"
//                 onClick={() => navigate('/dashboard/bot-creation-wizard')}
//                 iconName="Wrench"
//                 iconPosition="left"
//               >
//                 Create Strategy
//               </Button>
//               <Button
//                 onClick={() => navigate('/dashboard/bot-marketplace')}
//                 iconName="Store"
//                 iconPosition="left"
//               >
//                 Browse Bots
//               </Button>
//             </div>
//           </div>

//           {/* Quick Actions */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//             {quickActions?.map((action, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 onClick={action?.action}
//                 className="bg-card border border-border rounded-lg p-2 md:p-4 cursor-pointer hover:bg-muted/50 trading-transition group"
//               >
//                 <div className="flex items-center space-x-3">
//                   <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${action?.color === 'primary' ? 'bg-primary/10 text-primary' :
//                       action?.color === 'success' ? 'bg-success/10 text-success' :
//                         action?.color === 'warning' ? 'bg-warning/10 text-warning' : 'bg-accent/10 text-accent'
//                     }`}>
//                     <Icon name={action?.icon} size={20} />
//                   </div>
//                   <div className="flex-1">
//                     <h3 className="font-medium text-foreground group-hover:text-primary trading-transition">
//                       {action?.title}
//                     </h3>
//                     <p className="text-sm text-muted-foreground">{action?.description}</p>
//                   </div>
//                   <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-primary trading-transition" />
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </motion.div>

//         {/* Tab Navigation */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.2 }}
//           className="bg-card border border-border rounded-xl mb-6"
//         >
//           <div className="flex border-b border-border-secondary">
//             {tabs?.map((tab) => (
//               <button
//                 key={tab?.id}
//                 onClick={() => setActiveTab(tab?.id)}
//                 className={`flex items-center space-x-2 px-6 py-4 text-sm font-medium border-b-2 trading-transition ${activeTab === tab?.id
//                     ? 'border-primary text-primary bg-primary/5' : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
//                   }`}
//               >
//                 <Icon name={tab?.icon} size={16} />
//                 <span>{tab?.label}</span>
//                 {tab?.count && (
//                   <span className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full">
//                     {tab?.count}
//                   </span>
//                 )}
//               </button>
//             ))}
//           </div>

//         </motion.div>

//         <div className="relative  bg-gradient-to-b fromy-900 via-gray-800 to-black text-white overflow-hidden">
//           <div className="max- mx-auto px-0 md:px-3 py-2">
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={activeTab}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -20 }}
//                 transition={{ duration: 0.4 }}
//               >
//                 {activeTab === "configure" && (
//                   <BacktestConfiguration onBacktestComplete={handleBacktestComplete} isRunning={isRunning} setIsRunning={setIsRunning} setresultloaded={setresultloaded}/>
//                 )}

//                 {activeTab === "results" && (
//                   <BacktestResults
//                     results={backtestResults}
//                     setActiveTab={setActiveTab}
//                     resultwithid={resultloaded}
//                   />
//                 )}

//                 {activeTab === "saved" && (
//                   <SavedBacktests

//                   onLoadSavedBacktest={handleLoadSavedBacktest}
                   
//                   />
//                 )}
//               </motion.div>
//             </AnimatePresence>

//             <LoadingOverlay
//               visible={isRunning}
//               icon={IoMdRocket}
//               message="Running Backtest..."
//               subtext="Analyzing trade entries, exits & performance..."
//             />
//           </div>
//         </div>

//         {showComparison && (
//           <ComparisonMode onClose={() => setShowComparison(false)} />
//         )}
//       </div>

//     </div>
//   );
// };

// export default BacktestingEngine;

import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import BacktestConfiguration from './components/BacktestConfiguration';
import BacktestResults from './components/BacktestResults';
import ComparisonMode from './components/ComparisonMode';
import SavedBacktests from './components/SavedBacktests';
import LoadingOverlay from 'components/ui/LoadingOverlay';
import { IoMdRocket } from "react-icons/io";
import apiUtils from 'utils/apiutils';

const BacktestingEngine = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('configure');
  const [backtestResults, setBacktestResults] = useState([]);
  const [resultloaded, setresultloaded] = useState(false);
  const [showComparison, setShowComparison] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const [resultOfId, setresultOfId] = useState("")

  const handleBacktestComplete = async (resultsPromise) => {
    setIsRunning(true);
    // Simulated delay
    const results = await new Promise((res) =>
      setTimeout(() => res(resultsPromise), 2500)
    );
    setBacktestResults(results);
    setIsRunning(false);
    setActiveTab("results");
  };


  const tabs = [
    { id: 'configure', label: 'Configure', icon: 'Settings', count: null },
    { id: 'results', label: 'Results', icon: 'BarChart3', count: null },
    // { id: 'saved', label: 'Saved', icon: 'Archive', count: null }
  ];

  const handleLoadSavedBacktest = async (id,selectedMainStrategy) => {
    try {
     
      setActiveTab("results");
      setresultloaded(false)
      setresultOfId(id);

      const payload ={
        serial_No: id
      }

      const response = await apiUtils.post("/user_backtesting/view_backtest_detail", payload, { showToast: false });

      if (response) {
        setBacktestResults({ strategy_type: selectedMainStrategy,data:response.Success});
        
      } else {
        
      }
    } catch (error) {
      
    } finally {
      
    }
  };


  const quickActions = [
    // {
    //   title: 'Bot Marketplace',
    //   description: 'Browse pre-built strategies',
    //   icon: 'Store',
    //   action: () => navigate('/dashboard/bot-marketplace'),
    //   color: 'primary'
    // },
    {
      title: 'Create New Bot',
      description: 'Build custom strategy',
      icon: 'Wrench',
      action: () => navigate('/dashboard/bot-creation-wizard'),
      color: 'success'
    },
    {
      title: 'Paper Trading',
      description: 'Test with virtual funds',
      icon: 'FileText',
      action: () => navigate('/dashboard/paper-trading'),
      color: 'primary'
    },
    {
      title: 'Bot Analytics',
      description: 'View performance metrics',
      icon: 'Activity',
      action: () => navigate('/dashboard/bot-analytics'),
      color: 'primary'
    }
  ];

 

  return (
    <div className="bg-background">


      {/* <MainLoader/> */}
      <div className="p-6">
        {/* Page Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <div className="md:flex items-center justify-between mb-6">
            <div>
              <h1 className="text-3xl font-bold text-foreground mb-2">Backtesting Engine</h1>
              <p className="text-muted-foreground">
                Validate your trading strategies with comprehensive historical data analysis
              </p>
            </div>

            <div className="flex flex-col lg:flex-row items-center justify-end space-x-3">
              <Button
                // variant="outline"
                onClick={() => navigate('/dashboard/bot-creation-wizard')}
                iconName="Wrench"
                iconPosition="left"
              >
                Create Strategy
              </Button>
              {/* <Button
                onClick={() => navigate('/dashboard/bot-marketplace')}
                iconName="Store"
                iconPosition="left"
              >
                Browse Bots
              </Button> */}
            </div>
          </div>

          {/* Quick Actions */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
            {quickActions?.map((action, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                onClick={action?.action}
                className="bg-card border border-border rounded-lg p-2 md:p-4 cursor-pointer hover:bg-muted/50 trading-transition group"
              >
                <div className="flex items-center space-x-3">
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${action?.color === 'primary' ? 'bg-primary/10 text-primary' :
                      action?.color === 'success' ? 'bg-success/10 text-success' :
                        action?.color === 'warning' ? 'bg-warning/10 text-warning' : 'bg-accent/10 text-accent'
                    }`}>
                    <Icon name={action?.icon} size={20} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-medium text-foreground group-hover:text-primary trading-transition">
                      {action?.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">{action?.description}</p>
                  </div>
                  <Icon name="ChevronRight" size={16} className="text-muted-foreground group-hover:text-primary trading-transition" />
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Tab Navigation */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-card border border-border rounded-xl mb-6"
        >
          <div className="flex border-b border-border-secondary">
            {/* Mobile: Dropdown + Active Tab */}
            <div className="md:hidden flex-1 relative">
              <select
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
                className="w-full px-4 py-3 text-sm font-medium text-left border-b-2 border-transparent text-muted-foreground bg-transparent focus:border-primary focus:text-primary focus:outline-none appearance-none cursor-pointer"
              >
                {tabs?.map((tab) => (
                  <option key={tab?.id} value={tab?.id} className="bg-card text-foreground">
                    {tab?.label}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
                <Icon name="ChevronDown" size={16} className="text-muted-foreground" />
              </div>
            </div>

            {/* Desktop: Horizontal Tabs */}
            <div className="hidden md:flex">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center space-x-2 px-6 py-4 text-sm font-medium border-b-2 trading-transition ${activeTab === tab?.id
                      ? 'border-primary text-primary bg-primary/5' : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
                    }`}
                >
                  <Icon name={tab?.icon} size={16} />
                  <span>{tab?.label}</span>
                  {tab?.count && (
                    <span className="bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full">
                      {tab?.count}
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>

        </motion.div>

        <div className="relative  bg-gradient-to-b fromy-900 via-gray-800 to-black text-white overflow-hidden">
          <div className="max- mx-auto px-0 md:px-3 py-2">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                {activeTab === "configure" && (
                  <BacktestConfiguration onBacktestComplete={handleBacktestComplete} isRunning={isRunning} setIsRunning={setIsRunning} setresultloaded={setresultloaded}/>
                )}

                {activeTab === "results" && (
                  <BacktestResults
                    results={backtestResults}
                    setActiveTab={setActiveTab}
                    resultwithid={resultloaded}
                  />
                )}

                {/* {activeTab === "saved" && (
                  <SavedBacktests

                  onLoadSavedBacktest={handleLoadSavedBacktest}
                   
                  />
                )} */}
              </motion.div>
            </AnimatePresence>

            <LoadingOverlay
              visible={isRunning}
              icon={IoMdRocket}
              message="Running Backtest..."
              subtext="Analyzing trade entries, exits & performance..."
            />
          </div>
        </div>

        {showComparison && (
          <ComparisonMode onClose={() => setShowComparison(false)} />
        )}
      </div>

    </div>
  );
};

export default BacktestingEngine;